import dbsService from "@/services/dbs";

// x-bks-sessionid必須
export const postDbsReservation = async (params) => {
  try {
    await dbsService.apiWithSessionIdWrapper("POST", `dbs/reservation`, params);
  } catch (err) {
    console.log('ERROR"" postDbsReservation()');
    throw err;
  }
};
